"use client"

import {
  Card,
  CardContent
} from "@/components/ui/card";
import Image from "next/image";
import Link from "next/link";
import SearchInput from "./searchInput";
import moment from "moment";
import { useEffect, useState } from "react";
import ApiFromClient from '@/lib/getFromClient';
import Pagination from "@/components/common/pagination";

const card = [
  {
    id: 0,
    src: "https://exalogic-store.s3.us-east-2.amazonaws.com/exc-academy/blogs/blog-sap-banner-1.webp",
    date: "October 19 2022",
    time: "5 min Read",
    cardtitle: "ExC Academy Launches First Course: Master SAP Ariba and Unlock Supply Chain Excellence!",
    carddescription: "SAP is the Enterprise Resource Planning (ERP) software that’s used by millions of organizations across the globe to manage their business operations and customer relations in a smooth, hassle-free way. Whichever industry domain you belong to – manufacturing, healthcare, advertising and media, finance etc.,",
    properties: "Technology",
    link: "blog/blog-details",

  },
]
// type BannerProps = {
//   blogs: any;
// };
const RecentCard = () => {
  const [items, setItems] = useState<any>([]);
  const [count, setCount] = useState<any>();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(6);
  const [category, setCategory] = useState<any>("");
  const [load, setLoad] = useState<any>(false);

  useEffect(() => {
    async function getAllLeadsLists() {
      try {
        setItems([])
        setCount(null)
        setLoad(true)

        let queryParams = `?pageSizeRequested=${pageSize}&currentPage=${page}`
        if (category)
          setPage(1)
          queryParams += `&category=${category}`
        const response = await ApiFromClient.get(`/blogs/getAllNewBlogsForSite${queryParams}`);

        setItems(response?.data);
        setCount(Math.ceil(response?.data?.dataCount / pageSize));
        setLoad(false)
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
    getAllLeadsLists();
  }, [page, pageSize, category]);

  return (
    <div className="bg-[#F5F5F5] py-4 lg:py-14 md:py-14">
      <div className="container" >
        <div className="grid grid-cols-12 gap-4 pb-7 items-center">
          <div className="lg:col-span-8 md:col-span-6 sm:col-span-4 col-span-12">
            <div className="flex">
              <Image
                height={20}
                width={5}
                src="https://exalogic-store.s3.us-east-2.amazonaws.com/exc-academy/blogs/rectangle-line.webp"
                alt="rectanagle-img"
                className="h-[17px]"
                fetchPriority="high"
                loading="eager"
                rel="preload"
              />
              <h2 className="text-[#1F1F1F] text-xl font-semibold ml-2 leading-[16px] mb-4 sm:mb-0">Recent Articles</h2>
            </div>
          </div>
          <div className="lg:col-span-4 md:col-span-6 sm:col-span-8 col-span-12">
            <SearchInput setCategory={setCategory}/>
          </div>
        </div>
        <div className="grid grid-cols-12 gap-4 mb-4">
          {items?.dataCount === 0 && <h2 className=" w-screen h-50 flex items-center justify-center bg-transparent">No Data Found</h2>}
          {load ? <div className="w-screen h-screen flex items-center justify-center bg-transparent">
            <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-[#B484CC]"></div>
          </div> : <>
          {items?.data?.map((card: Article, index: any) => (
            <div key={card.id} className="lg:col-span-4 md:col-span-6 col-span-12">
              <Link href={`blog/${card.slug}`}>
                <Card className="relative rounded-none border-sm group">
                  <div className="h-[217px] overflow-hidden">
                    <Image
                      height={300}
                      width={300}
                      src={card.mobile_image}
                      alt="recent-article-img"
                      className="w-[100%] h-[217px] object-cover"
                      fetchPriority="high"
                      loading="eager"
                      rel="preload"
                    />
                  </div>
                  <div className="bg-[url('https://exalogic-store.s3.us-east-2.amazonaws.com/exc-academy/blogs/blog-card-bg.webp')] w-[100%] xl:h-[61px] sm:h-[51px] h-[50px] bg-no-repeat bg-[length:100%_100%]">
                    <div className="grid grid-cols-12 gap-4 px-5 py-4">
                      <div className="sm:col-span-6 col-span-12">
                        <div className="flex">
                          <Image
                            height={20}
                            width={20}
                            src="https://exalogic-store.s3.us-east-2.amazonaws.com/exc-academy/blogs/calender-icon.webp"
                            alt="calender-img"
                            className="xl:h-[21px] h-[17px]"
                            fetchPriority="high"
                            loading="eager"
                            rel="preload"
                          />
                          {/* <div className='ml-2 xl:text-base text-sm text-[#302A33]'>{moment(card.publication_date).format('MMM Do, YYYY')}</div> */}
                          {/* <div className='ml-2 xl:text-base text-sm text-[#302A33]'>Jan 15th, 2024</div> */}
                          <div className='ml-2 xl:text-base text-sm text-[#302A33]'>{moment(card.publish_date).format('MMM Do, YYYY')}</div>
                        </div>
                      </div>
                      <div className="sm:col-span-6 text-end col-span-12">
                        {/* <div className="flex justify-end">
                          <Image
                            height={20}
                            width={20}
                            src="https://exalogic-store.s3.us-east-2.amazonaws.com/exc-academy/blogs/clock-icon.webp"
                            alt="clock-img"
                            className="xl:h-[21px] h-[17px]"
                          />
                          <div className='ml-2 xl:text-base text-sm text-[#302A33]'>5 min Read</div>
                        </div> */}
                      </div>
                    </div>
                  </div>
                  <CardContent className="lg:h-[13rem] md:h-[13rem] h-[15rem] pt-6 overflow-hidden">
                    <h3 className="text-base font-semibold text-[#1A1A1A] group-hover:text-[#9014DC] mb-4 line-clamp-4">{card?.title}</h3>
                    <p className="text-[1rem] lg:text-sm font-light text-[#181818] line-clamp-4 lg:mb-5 md:mb-5 mb-4" dangerouslySetInnerHTML={{ __html: card.description }}></p>
                    {/* <div className="text-end flex justify-end ">
                      <p className="border text-[20px] border-gray-600 rounded-full p-1 group-hover:text-[#9014DC] group-hover:border-[#9014DC]"><FaLongArrowAltRight  /></p>
                    </div> */}
                  </CardContent>
                  <Image
                    height={20}
                    width={80}
                    src="https://exalogic-store.s3.us-east-2.amazonaws.com/exc-academy/blogs/stright.webp"
                    alt="stright-img"
                    className="w-[100%] mt-3"
                    fetchPriority="high"
                    loading="eager"
                    rel="preload"
                  />
                </Card>
              </Link>
            </div>
          ))}</>}
        </div>
      </div>
      {items?.length == 0 ? "":
      <div className="blog_pagination">
          <Pagination count={count} setPage={setPage} page={page}/>
      </div>}
    </div>
  )
}
export default RecentCard;